export const personalInfo = {
  name: "Mustafa Lokhandwala",
  title: "Senior Flutter Developer",
  email: "lokhandwalamustafa53@outlook.com",
  phone: "+91 83476 74753",
  location: "Limbdi, Gujarat, India",
  linkedin: "https://www.linkedin.com/in/mustafa-lokhandwala-487947123",
  instagram: "https://www.instagram.com/mustafa_mtfa/",
  instagramBusiness: "https://www.instagram.com/madeinflutter/",
  github: "https://github.com/mustafal",
  summary: "Senior Flutter Developer with 8+ years of experience in mobile application development, specializing in Flutter for over 6 years. Proven expertise in architecting scalable, cross-platform applications using Clean Architecture and advanced state management (Bloc, Riverpod). I have also developed AI-driven applications and possess expertise in no-code/low-code tools like Cursor, Replit, Rocket.new, and FlutterFlow. Additionally, I am proficient with AI tools like Claude Sonnet and CLI tools such as Gemini CLI and Qwen CLI. Adept at integrating third-party services (Firebase, Google APIs), optimizing app performance, and managing end-to-end deployment processes. Collaborative team player with a focus on delivering high-quality, user-centric applications."
};

export const skills = {
  languages: ["Dart", "Java", "Kotlin"],
  frameworks: ["Flutter", "Ionic", "REST APIs", "Firebase", "Google APIs"],
  architectures: ["Clean Architecture", "MVC", "MVVM", "SOLID Principles"],
  stateManagement: ["Bloc", "Provider", "Riverpod", "GetX"],
  tools: ["Git", "BitBucket", "Azure DevOps", "Codemagic", "AppDynamics", "PowerBI"],
  aiAndNoCode: ["Cursor", "Replit", "FlutterFlow", "Claude Sonnet", "Gemini CLI", "Qwen CLI"],
  databases: ["SQLite", "RoomDB", "Realm", "Hive"],
  other: ["Payment Gateway Integration (Stripe, Razorpay)", "Agile Methodology"]
};

export const experience = [
  {
    role: "Senior Software Engineer",
    company: "Tech Mahindra",
    duration: "Nov 2022 – June 2025",
    location: "Gandhinagar",
    projects: [
      {
        name: "PepsiCo GRA (Grower Relationship App)",
        description: "Developed cross-platform modules (iOS, Android, Web) with offline data access and location services. Led integration of OKTA Authentication, Dynamic Links, and App Dynamics monitoring. Designed responsive UIs ensuring 100% widget test coverage. Collaborated on Azure DevOps CI/CD pipelines and PowerBI reporting dashboards."
      },
      {
        name: "DEI POS Application (DigiPhoto Entertainment Imaging LLC)",
        description: "Built custom animations and transitions enhancing UX and app usability. Conducted POCs to address client-specific requirements with architectural solutions. Actively participated in weekly client meetings and code reviews to maintain high code quality."
      }
    ]
  },
  {
    role: "Software Engineer",
    company: "Peerbits Solutions Pvt. Ltd.",
    duration: "Feb 2020 – Nov 2022",
    location: "Ahmedabad",
    projects: [
      {
        name: "AB Money (Aditya Birla)",
        description: "Developed live stock price update modules using SignalR. Implemented stock purchase and sell functionalities with Provider for state management. Enhanced app efficiency by continuously evaluating and integrating new technologies."
      },
      {
        name: "MyLibri Books (Digital Library)",
        description: "Managed in-app purchases and book reading module with seamless subscription features. Streamlined CI/CD processes using Codemagic."
      }
    ]
  },
  {
    role: "Android Developer",
    company: "Serpent Consulting Services Pvt. Ltd.",
    duration: "Dec 2016 – Jan 2020",
    location: "Gandhinagar",
    projects: [
      {
        name: "Field Service Management App",
        description: "Developed a Flutter-based field service app with distinct user logins (Worker, Dispatcher, Admin). Managed real-time order flow processes and enhanced service coordination."
      }
    ]
  }
];

export const education = [
  {
    degree: "MSc IT",
    institution: "GLS University",
    location: "Ahmedabad",
    duration: "May 2015 – Apr 2017"
  },
  {
    degree: "BSc IT",
    institution: "Saurashtra University",
    location: "Surendranagar",
    duration: "Jun 2012 – Mar 2015"
  }
];

export const achievements = [
  "Delivered applications serving over 100K+ users across multiple platforms.",
  "Reduced app load times by 30% through performance optimizations.",
  "Achieved 97% test coverage in key Flutter modules ensuring robust deployments."
];

export const companies = [
  {
    name: "Tech Mahindra",
    role: "Senior Software Engineer",
    duration: "Nov 2022 – June 2025",
    description: "Leading Flutter development for enterprise clients including PepsiCo and DigiPhoto Entertainment",
    icon: "TM"
  },
  {
    name: "Peerbits Solutions",
    role: "Software Engineer",
    duration: "Feb 2020 – Nov 2022",
    description: "Developed fintech and digital library applications with advanced state management",
    icon: "PS"
  },
  {
    name: "Serpent Consulting",
    role: "Android Developer",
    duration: "Dec 2016 – Jan 2020",
    description: "Built field service management solutions with real-time order processing",
    icon: "SC"
  }
];

export const portfolioProjects = [
  {
    name: "PepsiCo GRA (Grower Relationship App)",
    role: "Sr. Software Engineer",
    tech: "Flutter, Dart",
    description: "Grower Relationship App is an app that is designed for the grower-facing procurement team to enhance farm visit management through features like offline access to farm visit data and location mapping, and reporting. It allows users to manage farm details, grower information, visit histories, and action plans, while providing integration with location services.",
    link: "https://gra.pepsico.com"
  },
  {
    name: "DEI (DigiPhoto Entertainment Imaging LLC) - B2B Application",
    role: "Sr. Software Engineer",
    tech: "Flutter, Dart",
    description: "DEI is a Point-of-Sale application developed in the Flutter Framework. The app helps the client to sell images that are captured at a particular site or location either digitally or a printed copy which can be purchased along with a Photo frame at the POS."
  },
  {
    name: "AB (Aditya Birla) Money",
    role: "Developer",
    tech: "Flutter",
    description: "One-stop-shop solution for all stock market enthusiasts. Track and trade equities and derivatives at your convenience. Simple and hassle-free. Seamless movement across information platforms and trading sections. Keeps you well-informed by sending alerts and updates on market trends."
  },
  {
    name: "MyLibri Books",
    role: "Developer",
    tech: "Flutter",
    description: "MyLibriBooks is a digital library where people will have access to thousands of over the internet. It comprises of different types of books ranging from academic books for subscribers who are still in school and for professionals in various areas of expertise such as Science and Technology, Financial and Banking sectors, to Fiction, Romantic and Non-fictional Books.",
    link: "https://play.google.com/store/apps/details?id=com.libribooks"
  },
  {
    name: "Moniwyse",
    role: "Developer",
    tech: "Flutter",
    description: "Moniwyse gives you a platform to see where your money goes, what your income is, the sources of your income, and generally how you spend your money. You can set up your financial plan in minutes."
  },
  {
    name: "KidCoins",
    role: "Developer",
    tech: "Flutter",
    description: "App that can have a socially connected family."
  },
  {
    name: "Hire Plus Recruiter",
    role: "Developer",
    tech: "Flutter",
    description: "This app will allow the recruiter to search the best profiles for the hiring process. Features: Dashboard, Find Candidates, Filter Candidates by different categories, Create/Manage Proposals, Chat with candidates."
  },
  {
    name: "Fuely Captain",
    role: "Developer",
    tech: "Flutter",
    description: "Driver app for fuel delivery."
  },
  {
    name: "Hire Plus Candidate",
    role: "Developer",
    tech: "Flutter",
    description: "This Hire+ app will allow any professional looking for a new challenge to find his dream job. Features: Dashboard, Browse companies, Company Details, Swiping Card View (Tinder) for accepting and rejecting proposals, Chat with companies."
  },
  {
    name: "Field Service Management",
    role: "Sr. Developer",
    tech: "Flutter",
    description: "A flutter app that provides a field service for worker and dispatcher. Features include viewing orders, taking pictures/signatures, managing equipment, and tracking location."
  },
  {
    name: "Self-Checkout app",
    role: "Team Leader",
    tech: "Flutter",
    description: "Flutter app for self-checkout for a specific shop. Features: Scan barcode, View Product by categories, Check out, Google/Facebook Login, View Offers/Coupons."
  },
  {
    name: "Easy Accounting",
    role: "Developer",
    tech: "Android",
    description: "Easy accounting is an android mobile app that manages the daily expenses of the user by category."
  },
  {
    name: "Restaurant POS",
    role: "Developer",
    tech: "Android",
    description: "Restaurant POS is an android app that takes online and offline orders with odoo server module. Features: Waiter Login, Choose Tables, Make Delivery, Take away order, Track Order, Manage Order Queue."
  },
  {
    name: "Gym Management System",
    role: "Developer",
    tech: "Ionic",
    description: "GMS is the ionic app with odoo server module that shows data of workouts and, diet history. It also manages the data of your running steps by the google fit app."
  },
  {
    name: "LittleBits",
    role: "Developer",
    tech: "Android",
    description: "An android app for the trading of virtual currency like BTC, ETH, etc. Features: OTP Sign In, PIN authentication, Push Notifications, Submit Bank/Aadhar/PAN details, Trading, Buy/Sell Coins, Payments."
  },
  {
    name: "Ang Security",
    role: "Developer",
    tech: "Android",
    description: "An android app for security guards. Features: Check-in/Check out using beacons, Patrolling Using Beacons, Submit Incident Report."
  },
  {
    name: "Visitor Management System",
    role: "Developer",
    tech: "Android",
    description: "An android app for handling visitors in enterprises. Features: Create new visitor, Check-in/out with QR code, Recent visitors list."
  },
  {
    name: "Digitrade V3",
    role: "Developer",
    tech: "Ionic",
    description: "An ionic app that scans a barcode and fetch the products from the server. Features: Scan Barcode, Settings, Follow up products, Add to cart."
  },
  {
    name: "SatAir app",
    role: "Developer",
    tech: "Android",
    description: "Android SMB client with scanning facility. Scan QR code and download/upload files from SMB server."
  },
  {
    name: "GasBip Rider App",
    role: "Developer",
    tech: "Android",
    description: "Used by a delivery boy who delivers the cylinder with the help of the App. The orders are tracked by the map and accept and cancel the order."
  },
  {
    name: "KeionGas Rider App",
    role: "Developer",
    tech: "Android",
    description: "Used by delivery boy app who delivers the cylinder with the help of the App. The orders are tracked by the map."
  },
  {
    name: "LeafGas User App",
    role: "Developer",
    tech: "Android",
    description: "LeafGas User app is an android app for users who wants to order the Gas Cylinder. Gas cylinders have a security deposit to pay which is also can pay online."
  },
  {
    name: "LeafGas Rider App",
    role: "Developer",
    tech: "Android",
    description: "Used by delivery boy app who delivers the cylinder with the help of the App. The orders are tracked by the map."
  },
  {
    name: "MpDS",
    role: "Developer",
    tech: "React Native",
    description: "MpDS is a tool specifically designed for health professionals that allows them to automatically capture clinical imaging of pressure ulcers and other wounds."
  }
];
